import { useEffect, useState } from "react";
import { Loader, Stack, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SmsType } from "@/models/club";
import useStore, { MessageGroupType, MessageType } from "@/store/message";
import CampaignPage, { CampaignActions } from "@/modules/marketing/CampaignPage";
import TemplatePicker, { useMessageParts } from "@/modules/marketing/TemplatePicker";
import { useSmartAudiences } from "@/services/smartAudience/hooks";
export default function SelectTemplate() {
  const store = useStore();
  const [selected, setSelected] = useState(store.smsTemplate);
  const navigate = useNavigate();
  // A home hint links here as ?audience=<key>[&member=<id>]: choose that smart audience, then show its templates.
  const [params, setParams] = useSearchParams();
  const audienceKey = params.get("audience");
  const member = Number(params.get("member")) || undefined;
  const audiences = useSmartAudiences({ merchantUserId: member, enabled: Boolean(audienceKey) });
  useEffect(() => {
    if (!audienceKey || audiences.isLoading) return;
    const audience = audiences.data?.find(item => item.key === audienceKey);
    setParams({}, { replace: true });
    if (!audience) {
      notifications.show({ color: "yellow", message: audiences.isError ? "پیشنهاد دریافت نشد. دوباره تلاش کنید." : "این پیشنهاد دیگر مخاطبی ندارد." });
      navigate("/dashboard/marketing", { replace: true });
      return;
    }
    store.setCustomers({ type: MessageType.messageGroup, groupType: MessageGroupType.smartAudience, smartAudience: { ...audience, merchantUserId: member }, excludeCustomerIds: [], customerGroup: undefined, discountGroup: undefined, discountGroupCount: audience.customerCount, customers: [] });
    store.setTemplate({ smsTemplate: undefined });
    setSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audienceKey, audiences.isLoading, audiences.data, audiences.isError]);
  const smart = store.groupType === MessageGroupType.smartAudience ? store.smartAudience : undefined;
  const parts = useMessageParts(selected?.text, smart ? smart.service?.title ?? null : undefined);
  const next = () => { if (!selected?.id) return; store.setTemplate({smsTemplate:selected}); navigate("/dashboard/messages/factor"); };
  if (audienceKey) return <Stack align="center" justify="center" mih={240} gap="sm"><Loader color="violet" /><Text size="sm" c="dimmed">در حال آماده کردن مخاطبان…</Text></Stack>;
  return <CampaignPage flow="customers" step={1} title="متنی انتخاب کنید که دیده شود" description="متن مناسب را انتخاب کنید و پیش‌نمایش آن را قبل از ادامه ببینید." previewText={selected?.text ?? ""} mobilePreview={false} actions={<CampaignActions back="/dashboard/messages/selectUser" next="ادامه؛ بررسی و هزینه" onNext={next} disabled={!selected?.id} hint={selected ? `متن: ${selected.title}` : "یک متن برای پیامک انتخاب کنید"} meta={parts} />}>
    <TemplatePicker smsType={SmsType.Value0} value={selected} onChange={setSelected} audienceKey={smart?.key ?? undefined} serviceTitle={smart?.service?.title} />
  </CampaignPage>;
}
